import { Environment, Subsidiary } from '@coolblue-development/constants';
import { fullWidthRatios, supportedDevicePixelRatios, } from './constants/supportedDevicePixelRatios.js';
import { getClosestAvailableWidthByPixelRatio, getInitialImageByWidth } from './imageDimension.js';
export const getImageUrl = ({ imageId, fileCollection, width: desiredWidth, background = 'solid', fullWidth = false, environment, subsidiary, }) => {
    // Object fit is no longer done on the image server, but with css' object-fit, therefore we always return max.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
    // Max renders the requested image, scaled to fit within the boundaries of the given dimension,
    // while retaining its  original aspect ratio.
    const getImageServerObjectFitSegment = 'max';
    const backgroundSegment = getBackgroundSegment(background);
    const fileCollectionSegment = getFileCollectionSegment(fileCollection);
    const base = `https://${getHostName(environment, subsidiary)}`;
    const srcImageWidth = getInitialImageByWidth(desiredWidth);
    const imageRatios = fullWidth ? fullWidthRatios : supportedDevicePixelRatios;
    return imageRatios.map(pixelRatio => {
        const responsiveImageWidth = getClosestAvailableWidthByPixelRatio(srcImageWidth, pixelRatio);
        const widthHeightSegment = getWidthHeightSegment(responsiveImageWidth);
        const segments = [
            backgroundSegment,
            getImageServerObjectFitSegment,
            widthHeightSegment,
            fileCollectionSegment,
            imageId,
        ]
            .filter(Boolean)
            .join('/');
        const url = `${base}/${segments}`;
        return {
            url,
            width: responsiveImageWidth,
            requestedPixelRatio: pixelRatio,
        };
    });
};
const imageHosts = {
    [Subsidiary.NL]: {
        [Environment.DEVELOPMENT]: 'image.coolblue.nl.tst.zone',
        [Environment.CI]: 'image.coolblue.nl.tst.zone',
        [Environment.TESTING]: 'image.coolblue.nl.tst.zone',
        [Environment.ACCEPTANCE]: 'image.coolblue.nl.accept.zone',
        [Environment.PRODUCTION]: 'image.coolblue.nl',
    },
    [Subsidiary.BE]: {
        [Environment.DEVELOPMENT]: 'image.coolblue.be.tst.zone',
        [Environment.CI]: 'image.coolblue.be.tst.zone',
        [Environment.TESTING]: 'image.coolblue.be.tst.zone',
        [Environment.ACCEPTANCE]: 'image.coolblue.be.accept.zone',
        [Environment.PRODUCTION]: 'image.coolblue.be',
    },
    [Subsidiary.DE]: {
        [Environment.DEVELOPMENT]: 'image.coolblue.de.tst.zone',
        [Environment.CI]: 'image.coolblue.de.tst.zone',
        [Environment.TESTING]: 'image.coolblue.de.tst.zone',
        [Environment.ACCEPTANCE]: 'image.coolblue.de.accept.zone',
        [Environment.PRODUCTION]: 'image.coolblue.de',
    },
};
const getHostName = (environment, subsidiary) => {
    return imageHosts[subsidiary][environment];
};
const getBackgroundSegment = (background) => {
    switch (background) {
        case 'transparent':
            return 'transparent';
        case 'solid':
        default:
            return '';
    }
};
const getWidthHeightSegment = (width) => {
    // we always want to keep the aspect ratio and let the client handle the object-fit
    const height = 'auto';
    return `${width}x${height}`;
};
const getFileCollectionSegment = (fileCollection) => {
    switch (fileCollection) {
        case 'content':
            return 'content';
        case 'product':
            return 'products';
        case 'review':
            return 'reviews';
        case 'second_chance_product':
            return 'secondchance';
        default:
            return '';
    }
};
//# sourceMappingURL=imageUrl.js.map